import Aptitude from "./Aptitude";

export default Aptitude;
